import { v4 as uuid } from 'uuid';
import { uniqBy } from 'ramda';

import { LOCAL_STORE_ITEMS } from '../../constants';
import { IImageFileSource } from '../../types';

export const parseImageUrl = (url: string, data?: Partial<IImageFileSource>) => {
  const fileName = url.split('/').pop()?.split('?')?.shift();
  const [name, extension] = fileName?.split('.') || [];
  return {
    ...data,
    id: uuid(),
    fileName,
    extension,
    name,
    url,
  } as IImageFileSource;
};

export const getRemovedProductIndexs = () => {
  let removedPorductIndexs: number[] = [];
  try {
    removedPorductIndexs = JSON.parse(localStorage.getItem(LOCAL_STORE_ITEMS.REMOVED_PRODUCT_INDEXS) || '[]').map(
      (index: string) => Number(index)
    );
  } catch {
    removedPorductIndexs = [];
  }

  return removedPorductIndexs;
};

export const addRemovedProductIds = (index: number) => {
  const removedPorductIndexs = getRemovedProductIndexs();

  localStorage.setItem(
    LOCAL_STORE_ITEMS.REMOVED_PRODUCT_INDEXS,
    JSON.stringify(uniqBy(item => item, [...removedPorductIndexs, index]))
  );
};

export {
  parseDateString,
  computeBaseItems,
  correctCorrespondingValues,
  getCellValue,
  getEnumValue,
  convertStringToBoolean,
  convertBooleanValue,
  isValidEANValue,
  isWrongTypeCell,
  isEmptyCell,
  isInvalidValueCell,
  isMandatoryCell,
  isEanDuplicated,
  isEanExist,
  isErrorCell,
  getErrorCell,
  getErrorRowCells,
  checkEnumType,
  getDataType,
  checkSameWithSavedBooleanValue,
  checkSameWithSavedValue,
  checkValueReviewed,
} from './cell';
export { savedDataMatchesEan } from './savedData';
export {
  correctColumnOrders,
  checkExtraCorrespondingColumn,
  addExtraCorrespondingColumn,
  mapExcelColumn,
  getColumnsByCategoryType,
  insertColumnList,
  updateMandatoryColumns,
  removeUnnecessaryColumns,
  getFirstQuestionColumn,
} from './column';
export { loadExcelFile } from './loadExcelFile';
export { readExcelFile } from './readExcelFile';
export { writeExcelFile } from './writeExcelFile';
export {
  getShortTitle,
  getCategofyColumnByTitle,
  findExcelHeaderRowIndex,
  parseExcelDataToProduct,
} from './parseExcelDataToProduct';
